export { AboutTheProduct } from "./AboutTheProduct";
export type { AboutTheProductProps, UseAndCareGuide } from "./AboutTheProduct";
